var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('img',{attrs:{"alt":"Vue logo","src":"https://cdn.siriushd.net/静的/シリウスロゴ.webp"}}),_c('HelloWorld',{attrs:{"msg":"このウェブサイトは現在作成中です。"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }